import getToken from '../cognito';
import turnstileService from '../turnstile';
import { createPaymentRequestSession } from './paymentJS.migrated';


const createPaymentIntent = async ({
  centAmount,
  currency,
  storeKey,
  paymentMethodConfigurationId,
}) => {
  try {
    const turnstileResponse = await turnstileService.getResponse();
    let accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
      accessToken = await getToken();
      localStorage.setItem('access_token', accessToken);
    }
    const response = await fetch(
      `${process.env.BASE_API_URL}/payment-hub/create-intent`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          'Turnstile-Response': turnstileResponse,
        },
        body: JSON.stringify({
          centAmount,
          currency,
          storeKey,
          paymentMethodConfigurationId,
        }),
      },
    );
    if (response.ok) {
      return await response.json();
    }
    throw response;
  } catch (error) {
    throw new Error(error.message);
  }
};

const getPaymentIntentDetails = async ({paymentId}) => {
  try {
    const response = await fetch(
      `${process.env.BASE_API_URL}/payment-hub/payment/${paymentId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
      },
    );
    if (response.ok) {
      return await response.json();
    }
    throw response;
  } catch (error) {
    throw new Error(error.message);
  }
};

const paymentJSService = {
  createPaymentRequestSession,
  createPaymentIntent,
  getPaymentIntentDetails,
};

export default paymentJSService;
